<template>
  <div
    id="tabulator"
    ref="tableRef"
    class="table-report table-report--tabulator"
    :data-test="`${tableName}-data-table`"
  />
</template>

<script setup>
import { ref, reactive, onMounted, watch } from "vue";
import feather from "feather-icons";
import Tabulator from "tabulator-tables";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import axios from "axios";
const props = defineProps({
  dataArrayTable: {
    type: Array,
  },
  paginationSize: {
    type: Number,
    default: 10,
  },
  paginationSizeArray: {
    type: Array,
    default: () => [10, 20, 50, 100],
  },
  dataArray: {
    type: Array,
  },
  apiUrl: {
    type: String,
  },
  tableName: {
    type: String,
    default: "init",
  },
  routerName: {
    type: String,
  },
  apiParams: {
    type: Object,
  },
  totalList: {
    type: Number,
  },
  methodRequest: {
    type: String,
  },
  downloadFile:{
    type: Boolean
  },
  downloadExtraParams:{ // extra api params merged in only for the downloadFile export fetch, not the visible table
    type: Object,
    default: () => ({})
  },
  initSorter:{//initial sort with column name define on table
    type: Array
  },
  customSort:{
    type: Array
  },
  questionGroup:{
    type: String
  },
  stackedMobile: {
    type: Boolean,
    default: false,
  }
})
const emits = defineEmits(["rowClicked", "getDataComplete"])
const tableRef = ref();
const tabulator = ref();
const totalLists = ref(0);
const MOBILE_BREAKPOINT = 1005;
// console.log("props ", props);    
const router = useRouter();
const store = useStore();    
const token = store.getters["userAuth/getToken"];
const normalizedColumns = () =>
  (props.dataArrayTable || []).map((column) => ({
    hozAlign: "left",
    headerHozAlign: "left",
    ...column,
  }));
const getTableElement = () => tableRef.value;
const getColumnLabel = (title = "") => String(title).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
const getColumnLabels = () => props.dataArrayTable.reduce((labels, column) => {
  if (column?.field) {
    labels[column.field] = getColumnLabel(column.title);
  }

  return labels;
}, {});
const setCellDataLabels = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  const labels = getColumnLabels();

  tableElement.querySelectorAll(".tabulator-cell").forEach((cell) => {
    const field = cell.getAttribute("tabulator-field");
    const label = labels[field] || "";

    if (label) {
      cell.setAttribute("data-label", label);
    }
  });
};
const showAllColumns = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  tableElement.querySelectorAll(".tabulator-col").forEach((col) => {
    if (col.style.display == "none") {
      col.style.display = "inline-block";
      col.setAttribute("hide", "true");
    }
  });
};
const syncCellWidths = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  tableElement.querySelectorAll(".tabulator-col").forEach((col) => {
    tableElement.querySelectorAll(".tabulator-cell").forEach((cell) => {
      if (
        cell.getAttribute("tabulator-field") ==
        col.getAttribute("tabulator-field")
      ) {
        cell.style.width = cell.style.width
          ? cell.style.width
          : cell.style.minWidth;
      }
    });
  });
};
const showAllCells = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  tableElement.querySelectorAll(".tabulator-cell").forEach((cell) => {
    cell.style.display = "inline-flex";
    cell.style.removeProperty("height");
  });
};
const applyDefaultMobileLayout = () => {
  const tableElement = getTableElement();

  if (!tableElement) {
    return;
  }

  tableElement.querySelectorAll(".tabulator-col").forEach((col) => {
    if (col.hasAttribute("hide")) {
      tableElement.querySelectorAll(".tabulator-cell").forEach((cell) => {
        if (
          col.style.display == "inline-block" &&
          cell.getAttribute("tabulator-field") ==
            col.getAttribute("tabulator-field")
        ) {
          cell.style.display = "none";
          cell.style.removeProperty("height");
        }
      });
    } else {
      tableElement.querySelectorAll(".tabulator-cell").forEach((cell) => {
        if (
          col.style.display == "none" &&
          cell.getAttribute("tabulator-field") ==
            col.getAttribute("tabulator-field")
        ) {
          cell.style.display = "none";
          cell.style.removeProperty("height");
        }
      });
    }
  });
};
const syncResponsiveLayout = () => {
  const tableElement = getTableElement();

  if (!tableElement || !tabulator.value) {
    return;
  }

  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

  tableElement.classList.toggle("tabulator-mobile-stacked-mode", props.stackedMobile && isMobile);
  setCellDataLabels();

  if (!isMobile) {
    showAllColumns();
    syncCellWidths();
    showAllCells();
    return;
  }

  if (props.stackedMobile) {
    showAllColumns();
    showAllCells();
    return;
  }

  applyDefaultMobileLayout();
};
const initTabulator = () => {
  tabulator.value = new Tabulator(tableRef.value, {
    locale: "th-th",
    langs: {
      "th-th": {
        pagination: {
          page_size: "แสดง",
        },
      },
    },
    // data: props.dataArray,
    ajaxURL: `${process.env.VUE_APP_BASE_API}${props.apiUrl}`, //call api if using api no need to send dataArray
    ajaxConfig: {
      method: props.methodRequest,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
    // initialSort: props.initSorter,//set initial sort with column name define on table
    ajaxParams: props.apiParams,
    ajaxResponse: function(url, params, response) {
      document.querySelector(".totalList").innerHTML =
        new Intl.NumberFormat().format(response.recordsTotal);
      totalLists.value = response.recordsTotal
      return response; //return the tableData property of a response json object
    },
    /*rowSelectionChanged:function(data, rows){
        //update selected row counter on selection change
      console.log("daa ", data);
      console.log("r ", rows);
    },*/
    rowClick: function(e, row) {
      //emit function to parent to handle what to do
      emits("rowClicked", row._row.data)
    },
    pageLoaded: function(e, row) {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        tabulator.value.redraw();
      }

      syncResponsiveLayout();
    },
    layout: "fitColumns",
    responsiveLayout: "collapse",
    // pagination: 'local',
    ajaxSorting:true,
    pagination: "remote",
    paginationDataSent: {
      page: "start", //change page request parameter to "pageNo"
      size: "length",
    },
    ajaxRequesting:function(url, params){
    //url - the URL of the request
    //params - the parameters passed with the request
      if(params.sorters.length == 0){
        params.sorters = props.initSorter
      }
      params.sorters = params.sorters.map((item)=>{
        if(item.field == "house_surveys_status")
          item.field = "house_surveys.status"
        return item
      })

      params.sorters = JSON.stringify(params.sorters)
      return params
    },
    paginationDataReceived: {
      last_page: "maxPage", //change last_page parameter name to "max_pages"
    },
    headerSort: true,
    paginationSize: props.paginationSize,
    paginationSizeSelector: props.paginationSizeArray,
    cellVertAlign: "middle",
    placeholder: "ไม่มีข้อมูล",
    footerElement: `<span class="mb-1">ทั้งหมด <span class="totalList"></span> รายการ</span>`,
    columns: normalizedColumns(),
    columnHeaderSortMulti: true,
    renderComplete() {
      syncResponsiveLayout();

      if (props.stackedMobile && props.questionGroup === 'household' && window.innerWidth <= MOBILE_BREAKPOINT) {
        const rows = tabulator.value.getRows();
        rows.forEach((row) => {
          const data = row.getData();
          const address = data.address_num ? data.address_num : "";
          const village = data.village_name ? data.village_name : "";
          const badgeText = `${address} ${village}`.trim();
          
          const cells = row.getCells();
          if (cells.length > 0) {
            const firstCell = cells[0];
            const element = firstCell.getElement();
            element.removeAttribute('data-label');
            element.classList.add('household-row-header');
            if (!element.querySelector('.household-badge')) {
              element.insertAdjacentHTML(
                'afterbegin',
                `<span class="household-badge">${badgeText}</span>`
              );
            }
          }
        });
      }

      feather.replace({
        "stroke-width": 2,
      });
    },
  });
};

watch(()=> props.downloadFile, async (val)=>{
    if(val){
      const question_lists = await axios.get(`${process.env.VUE_APP_BASE_API}admin/question/questionnaire`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          params: {
            question_nare_name_en: props.questionGroup
          },
        }
      ).
      catch(err => err);
      const new_question_lists = question_lists.data.reduce((a,v)=>{
        let temp = []
        if(v.question_type == "multiple-inputs-group"){
          a = [...a, ...v.choices]
        }
        else{
          temp = [...temp, v]
        }
        return [...a, ...temp]
      }, [])
      const res = await axios.get(`${process.env.VUE_APP_BASE_API}${props.apiUrl}`,
        {
          params: {...props.apiParams, start: 1, draw: 10, length: totalLists.value, export: true, ...props.downloadExtraParams},
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        }
      ).
      catch(err => err);

      emits("getDataComplete", res, new_question_lists)
    }
  })
const testSort = () => {
  let ee = tabulator.value.getSorters();
};
// Redraw table onresize
const reInitOnResizeWindow = () => {
  syncResponsiveLayout();

  window.addEventListener("resize", () => {
    tabulator.value.redraw();
    syncResponsiveLayout();
    feather.replace({
      "stroke-width": 1.5,
    });
  });
};

onMounted(() => {
  initTabulator();
  reInitOnResizeWindow();
});

</script>
<style lang="scss">
.tabulator .tabulator-row .tabulator-responsive-collapse {
  display: none;
}
/* .tabulator .tabulator-header .tabulator-headers .tabulator-col, .tabulator .tabulator-row .tabulator-cell{
  display: inline-block !important;
  min-width: 80px;
  width: 200px;
} */
.tabulator .tabulator-row .tabulator-responsive-collapse td strong {
  font-weight: 600 !important;
}
.tabulator-cell[tabulator-field="full_name"] {
  font-weight: 600;
}
@media only screen and (max-width: 1005px) {
  .tabulator {
    .tabulator-tableHolder {
      // overflow: unset !important;
      .tabulator-table {
        white-space: normal !important;
        width: 100%;
        .tabulator-row .tabulator-responsive-collapse {
          display: block;
        }
      }
    }
  }

  .tabulator.tabulator-mobile-stacked-mode {
    border: 0;
    background: transparent;

    .tabulator-header {
      display: none;
    }

    .tabulator-tableHolder {
      overflow-x: hidden;

      .tabulator-table {
        width: 100% !important;
        background: transparent;
      }
    }

    .tabulator-row {
      display: block;
      //margin-bottom: 0.75rem;
      //border: 1px solid #e5e7eb;
      //border-radius: 0.75rem;
      overflow: hidden;
      background: #ffffff !important;
      border-bottom-width: 0;
      margin-bottom: 15px;
      border-radius: 10px;
    }

    .tabulator-row .tabulator-cell {
      display: flex !important;
      align-items: flex-start;
      justify-content: flex-start !important;
      text-align: left !important;
      gap: 0.75rem;
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      height: auto !important;
      padding: 0.875rem 1rem;
      white-space: normal !important;
      border-right: 0;
      // border-bottom: 1px solid #f1f5f9;
    }

    .tabulator-row .tabulator-cell.tabulator-align-center {
      justify-content: center !important;
      text-align: center !important;
    }

    .tabulator-row .tabulator-cell.tabulator-align-right {
      justify-content: flex-end !important;
      text-align: right !important;
    }

    .tabulator-row .tabulator-cell::before {
      content: attr(data-label);
      flex: 0 0 42%;
      max-width: 42%;
      font-weight: 600;
      word-break: break-word;
    }

    .tabulator-row .tabulator-cell.household-row-header::before {
      display: none;
    }

    .tabulator-row .tabulator-cell.household-row-header {
      background: #d9e8f6 !important;
      justify-content: space-between !important;
    }

    .tabulator-row .tabulator-cell.household-row-header .household-badge {
      // display: inline-flex;
      max-width: 182px;
      -webkit-line-clamp: 2;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      align-items: center;
      padding: 5px 11px;
      border-radius: 9999px;
      background: #246bc3;
      color: #ffffff;
      font-size: 0.875rem;
      font-weight: 600;
    }

    .tabulator-row .tabulator-cell:last-child {
      border-bottom: 0;
    }

    .tabulator-row .tabulator-cell > * {
      min-width: 0;
    }

    .tabulator-row .tabulator-responsive-collapse {
      display: none !important;
    }
    .tabulator-row:has(.t-tooltip:hover) {
      overflow: visible;
    }
  }
}
</style>
